/**
 * Copyright (C), 2012-2021, Sichuan Xiaoka Technology Co., Ltd.
 **/

import axios from 'axios'

/**
 * 封装get方法
 * @param url
 * @param params
 */
function getAxios(url, params, args) {
    return axios.get(url, {params, ...args}).then(config => {
        return config
    }).catch(err => {
        return err
    })
}

/**
 * 封装post方法
 * @param url
 * @param params
 */
function postAxios(url, params) {
    for (let i in params) {
        if (params[i] === null || params[i] === undefined) { // 去掉为空的字段
            params[i] = ''
        }
    }

    return axios.post(url, params).then(config => {
            return config
    }).catch(() => {
        // 当返回出现错误时，给接口调用部分返回false，错误情况的处理统一在响应拦截器中
        return false
    })
}

/**
 * 封装put方法
 * @param url
 * @param params
 */
function putAxios(url, params) {
    for (let i in params) {
        if (params[i] === null || params[i] === undefined) { // 去掉为空的字段
            params[i] = ''
        }
    }
    return axios.put(url, params).then(config => {
        return config
    }).catch(err => {
        return err
    })
}

/**
 * 封装delete方法
 * @param url
 * @param params
 */
function deleteAxios(url, params) {
    return axios.delete(url, {params}).then(config => {
        return config
    }).catch(err => {
        return err
    })
}

export default {
    getAxios,
    postAxios,
    putAxios,
    deleteAxios
}